export default __webpack_public_path__ + "static/nogap-7b7c15fd2c4c073464042dae30b6cd2b.png";